'use strict';

exports.__esModule = true;
exports.siteRevisionHeader = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* global Wix, publicModel, editorModel  */


var _urlUtils = require('./url-utils');

function getInterceptor(_ref) {
  var wixCodeApi = _ref.wixCodeApi;

  var requestSuccess = function requestSuccess(config) {
    var shouldAddSiteRevision = config.url.includes('/_api/');

    if (shouldAddSiteRevision) {
      var siteRevision = getSiteRevision(wixCodeApi);
      if (siteRevision) {
        var _extends2;

        var headers = _extends({}, config.headers, (_extends2 = {}, _extends2[siteRevisionHeader] = siteRevision, _extends2));
        return _extends({}, config, { headers: headers });
      }
    }
    return config;
  };
  return { requestSuccess: requestSuccess };
}

var getSiteRevision = function getSiteRevision(wixCodeApi) {
  if (typeof Wix !== 'undefined' && Wix.Utils && Wix.Utils.getSiteRevision) {
    return Wix.Utils.getSiteRevision();
  }
  var siteRevisionFromQueryParam = getSiteRevisionFromQueryParam();
  if (siteRevisionFromQueryParam) {
    return siteRevisionFromQueryParam;
  }
  if (wixCodeApi) {
    return wixCodeApi.site.revision;
  }
  if (typeof publicModel !== 'undefined' && publicModel.siteRevision) {
    return publicModel.siteRevision;
  }
  if (typeof editorModel !== 'undefined' && editorModel.siteHeader && editorModel.siteHeader.revision) {
    return editorModel.siteHeader.revision;
  }
};

var getSiteRevisionFromQueryParam = function getSiteRevisionFromQueryParam() {
  if (typeof window !== 'undefined' && window.location) {
    return (0, _urlUtils.extractQueryParam)(window.location, 'siteRevision');
  }
};

exports.default = { getInterceptor: getInterceptor };
var siteRevisionHeader = exports.siteRevisionHeader = 'x-wix-site-revision';